import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper,} from "@mui/material";

import { useRovingRows } from "./useRovingRows";
import TableSkeleton from "./TableSkeleton";
const StyledLink = styled(Link)({
  color:"inherit",
  textDecoration:"none"
})

const miscStyle = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "150px",
}

const PaginationTable = ({
  rows,
  headings,
  renderCell,
  customWidth,
  noRecordMessage = "",
  loading,
  link,
  path,
  id,
  tableStyle,
  paginationHide
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { bodyRef, rowProps } = useRovingRows();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", boxShadow: "none", elevation: 0 }}>
        <TableContainer sx={tableStyle?{...tableStyle}:{}}>
          <Table aria-busy={Boolean(loading)} sx={{  minWidth: customWidth || 550 }}>
            <TableHead>
              <TableRow>
                {headings?.map((heading, index) => (
                  <TableCell key={index} sx={heading.style}>
                    {heading.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody ref={bodyRef}>
            {loading ? (
              <TableSkeleton columns={headings?.length || 4} />
            ) : rows?.length > 0
                ? (rowsPerPage > 0
                    ? rows?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : rows
                  )?.map((row, rowIndex) => (
                    <TableRow 
                      hover 
                      key={rowIndex}
                      {...rowProps(rowIndex)}
                      component={link ? StyledLink : 'tr'}
                      to={link ? `${path}/${row._id || row[id]}` : null} 
                    >
                      {renderCell(row)}
                    </TableRow>
                  ))
                : <TableRow>
                    <TableCell colSpan={headings?.length}>
                       <Box sx={miscStyle}>
                          {noRecordMessage}
                        </Box>
                    </TableCell>
                  </TableRow>
                }
            </TableBody>
          </Table>
        </TableContainer>
        {!paginationHide && (
           <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              // "Page 3 of 12" answers the question people actually have;
              // MUI's default row range ("11-20 of 240") does not.
              labelDisplayedRows={({ count }) => {
                const total = Math.max(1, Math.ceil(count / rowsPerPage));
                return `Page ${page + 1} of ${total}`;
              }}
            />
        )}
      </Paper>
    </Box>
  );
};

export default PaginationTable;
